import * as React from 'react';
import cn from 'classnames';

import { IFooterItemOptions } from '../types';

import './FooterItem.modules.scss';

const FooterItem: React.FC<IFooterItemOptions> = ({
  title,
  handleClick,
  border,
  hoverable = true
}: IFooterItemOptions) => {
  return (
    <div
      styleName={cn('footer-item', hoverable && 'footer-item_hoverable')}
      className={cn(border && `popup-menu-item_${border}`)}
      onClick={handleClick}
    >
      {title}
    </div>
  );
};

export default FooterItem;
